require ('./lazyload.min.js');
require("@fancyapps/fancybox");
require("./carousel.js");
require("./submenu.js");

// CUSTOM
jQuery(document).ready(function($){


	// jQuery('a.splash')[0].click();

	$(window).scroll( () => {
		var windowTop = $(window).scrollTop();
		windowTop > 100 ? $('.nav-container').addClass('navShadow') : $('.nav-container').removeClass('navShadow');
		// windowTop > 100 ? $('ul').css('top','100px') : $('ul').css('top','160px');
	});
	var windowTop = $(window).scrollTop();
		windowTop > 100 ? $('.nav-container').addClass('navShadow') : $('.nav-container').removeClass('navShadow');
	$('#about-faq .question').click(function(){
		$('#about-faq .question').removeClass('hide')
  		$(this).addClass('hide');
  	});
  	$('#about-faq .reponse').click(function(){
		$('#about-faq .question').removeClass('hide');
  	});
	$('#photovoltaique-faq .question').click(function(){
		$('#photovoltaique-faq .reponse-container').removeClass('show')
  		$(this).parent().children('.reponse-container').addClass('show');
  	});
  	$('#photovoltaique-faq .close').click(function(){
  		$('#photovoltaique-faq .reponse-container').removeClass('show');
  	});
  	$('.services-item h3').click(function(){
		$('#services .descriptif-container').removeClass('show')
  		$(this).parent().children('.descriptif-container').addClass('show');
  	});
  	$('.services-item .close').on('click', function(){
  		$('.services-item .descriptif-container').removeClass('show');
  	});

	  // Add smooth scrolling to all links
  $("a.scroll-down").on('click', function(event) {

    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "") {
      // Prevent default anchor click behavior
      event.preventDefault();

      // Store hash
      var hash = this.hash;

      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      $('html, body').animate({
        scrollTop: $(hash).offset().top
      }, 800, function(){

        // Add hash (#) to URL when done scrolling (default click behavior)
        window.location.hash = hash;
      });
    } // End if
  });
  // 	$('.news-container').socialfeed({
  //     	// FACEBOOK
  //     	facebook:{
		// 	//Array: Specify a list of accounts from which to pull wall posts
		// 	accounts: ['@Ace Sun.photovoltaique'],
		// 	//Integer: max number of posts to load
		// 	limit: 6,
		// 	//String: "APP_ID|APP_SECRET"
		// 	access_token: '160822948031810|901c31f8622f190684428d899333d5e4'
		// },
  //     	// GENERAL SETTINGS
  //     	length: 200, //Integer: For posts with text longer than this length, show an ellipsis.
  //     	show_media: true,
  //     	//date_format: "YYYY MM DD",
  //     	date_locale: "fr",
  //     	template_html: //String: HTML used for each post. This overrides the 'template' filename option
  //     	'<article class="news-item grid-item"> \
		// 	<div class="news-info"> \
		// 		<div class="news-logo"> \
		// 			<a href="{{=it.author_link}}" target="blank"><img src="{{=it.author_picture}}" alt="Image de profil Facebook de Ace Sun" width="69" height="69"></a> \
		// 		</div> \
		// 		<span class="news-name">Ace Sun</span> \
		// 		<span class="news-date">{{=it.time_ago}}</span> \
		// 	</div> \
		// 	<div class="news-text"> \
		// 		<p>{{=it.text}}</p> \
		// 	</div> \
		// 	<div class="news-image">{{=it.attachment}}</div> \
  //     	</article>'
  // 	});
  	// $('.news-page-container').socialfeed({
   //    	// FACEBOOK
   //    	facebook:{
   //        	//Array: Specify a list of accounts from which to pull wall posts
   //        	accounts: ['@Ace Sun.photovoltaique'],
   //        	//Integer: max number of posts to load
   //        	limit: 20,
   //        	//String: "APP_ID|APP_SECRET"
   //        	access_token: '160822948031810|901c31f8622f190684428d899333d5e4'
   //    	},
   //    	// GENERAL SETTINGS
   //    	length: 200, //Integer: For posts with text longer than this length, show an ellipsis.
   //    	show_media: true,
   //    	//date_format: "YYYY MM DD",
   //    	date_locale: "fr",
   //    	template_html: //String: HTML used for each post. This overrides the 'template' filename option
   //    	'<article class="news-item"> \
			// <div class="news-info"> \
			// 	<div class="news-logo"> \
			// 		<a href="{{=it.author_link}}" target="blank"><img src="{{=it.author_picture}}" alt="Image de profil Facebook de Ace Sun" width="69" height="69"></a> \
			// 	</div> \
			// 	<span class="news-name">Ace Sun</span> \
			// 	<span class="news-date">{{=it.time_ago}}</span> \
			// </div> \
			// <div class="news-text"> \
			// 	<p>{{=it.text}}</p> \
			// </div> \
			// <div class="news-image">{{=it.attachment}}</div> \
   //    	</article>',
  	// });
  	var $grid = $('.grid-container').imagesLoaded( function() {
	  	// init Masonry after all images have loaded
	  	$grid.masonry({
	    	// columnWidth: '.grid-sizer',
  			itemSelector: '.news-item',
	  	});
	});
}); // END JQUERY
function toggleNavClass() {
	// SHOW MENU
    var nav = document.getElementById("navigation");
    nav.classList.toggle("show");
    // TOGGLE NAV ICON CLASS
    var icon = document.getElementById("nav-icon");
    if (icon.classList.contains("fa-bars")) {
    	icon.classList.remove("fa-bars");
    	icon.classList.add("fa-times");
    } else {
    	icon.classList.remove("fa-times");
    	icon.classList.add("fa-bars");
    }
};
jQuery('.nav-icon').on('click',function (){
	toggleNavClass();
})
// MASONRY
/*var elem = document.querySelector('.grid-container');
var msnry = new Masonry( elem, {
  columnWidth: '.grid-sizer',
  itemSelector: '.grid-item',
});
imagesLoaded( elem ).on( 'progress', function() {
  // layout Masonry after each image loads
  msnry.layout();
});*/
// GLIGHTBOX
// var lightboxDescription = GLightbox({
//   selector: 'glightbox'
// });
